import { useAuthStore } from "@/src/store/auth";

const apiUrl = {
  sandbox: "https://app-sandbox.thespotlight.pro",
  production: "https://app-api.thespotlight.pro",
};

type Environment = keyof typeof apiUrl;

const envName: Environment =
  (process.env.REACT_APP_ENV as Environment) ?? "production";

//export const url = 'http://192.168.178.36:8088';
export const url = apiUrl[envName];

async function handleResponse(response: Response): Promise<any> {
  if (response.status === 403) {
    // logout() clears both auth-storage and the jwtToken key — see store/auth.ts
    useAuthStore.getState().logout();
    throw new Error("Authentication failed");
  }

  if (response.status === 204) {
    return null;
  }

  if (response.status === 200 && !response.headers.get("content-type")) {
    return {};
  }

  if (response.status >= 400) {
    const errorText = await response.text();
    let errorMessage: string;
    try {
      const errorJson = JSON.parse(errorText);
      errorMessage =
        errorJson.err ||
        errorJson.message ||
        errorJson.error ||
        "An error occurred";
    } catch {
      errorMessage = errorText || "An error occurred";
    }

    throw new Error(errorMessage);
  }

  try {
    return await response.json();
  } catch (e) {
    return await response.text();
  }
}

async function baseFetch(
  fullUrl: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  body?: object | null,
): Promise<any> {
  const token = localStorage.getItem("jwtToken");

  const headers: HeadersInit = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  const config: RequestInit = {
    method,
    headers,
    ...(body && { body: JSON.stringify(body) }),
  };

  const response = await fetch(fullUrl, config);
  return handleResponse(response);
}

export const Post = (endpoint: string, body: object | null): Promise<any> => {
  return baseFetch(url + endpoint, "POST", body);
};

export const Put = (endpoint: string, body: object | null): Promise<any> => {
  return baseFetch(url + endpoint, "PUT", body);
};

export const Get = (endpoint: string): Promise<any> => {
  const fullUrl = endpoint.includes(url) ? endpoint : url + endpoint;
  return baseFetch(fullUrl, "GET");
};

export const Delete = (endpoint: string): Promise<any> => {
  return baseFetch(url + endpoint, "DELETE", null);
};
